import ModuleCardComponent from "../../../Module/ModuleCardComponent"
import "./DetailPageLearnComponent.scss"

const DetailPageLearnComponent = (props) => {

    const {
        learnData, onLearnClick, setIsLoading
    } = props; 

    return (
        <>
        <ModuleCardComponent
            moduleData={learnData}
            navigateToDetails={onLearnClick}
            setIsLoading={setIsLoading}
        />
        </>
    )
}

export default DetailPageLearnComponent